import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import ExtensionIcon from '@mui/icons-material/Extension'
import DownloadIcon from '@mui/icons-material/Download'
import { FormattedMessage } from 'react-intl'

function PackageCard({ pkg, onImport }) {
  return (
    <Box
      sx={{
        border: 1,
        borderColor: 'divider',
        borderRadius: 1,
        p: 2,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        {pkg.iconUrl ? (
          <Box
            component="img"
            src={pkg.iconUrl}
            alt={pkg.name}
            sx={{
              width: 48,
              height: 48,
              objectFit: 'contain',
              mr: 2,
            }}
          />
        ) : (
          <Box
            sx={{
              width: 48,
              height: 48,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              bgcolor: 'action.hover',
              borderRadius: 1,
              mr: 2,
            }}
          >
            <ExtensionIcon sx={{ color: 'text.secondary' }} />
          </Box>
        )}
        <Typography variant="h6" component="h3">
          {pkg.name}
        </Typography>
      </Box>
      {pkg.description && (
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{
            flexGrow: 1,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            WebkitLineClamp: 3,
            WebkitBoxOrient: 'vertical',
          }}
        >
          {pkg.description}
        </Typography>
      )}
      <Box sx={{ mt: 2 }}>
        <Button
          variant="outlined"
          size="small"
          startIcon={<DownloadIcon />}
          onClick={() => onImport(pkg)}
        >
          <FormattedMessage id="marketplace.import.button" />
        </Button>
      </Box>
    </Box>
  )
}

export default PackageCard
